<script>
    import { user } from './stores.js';

    function logout() {
        user.set(null);
        window.location.assign("#login");
    }
</script>

<button on:click={logout} title="Logout">Logout</button>